import {
  getVendorListForImport,
  getVendorTemplate,
  importVendors,
} from "@ckweb/ckfetch/connectables/equipmentAreaManagement";

const FETCH_ID = "Manufacturers";

export const useGetManufacturersTemplate = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}Template`, getVendorTemplate, {
    fetchType: "download",
    showGlobalLoadingIndicator: true,
  });

export const useGetManufacturersForImport = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}`, getVendorListForImport, {
    fallback: (data) => data?.data || [],
  });

export const useSubmitManufacturers = () =>
  useSafeLocalFetch(`import${FETCH_ID}`, importVendors, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });
